import React from 'react';
import history from '../../core/history';
import withStyles from '../../core/isomorphic-style-loader/withStyles';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module './Logo.css' or its correspondi... Remove this comment to see the full error message
import s from './Logo.css';

const goHome = () => history.push('/');

const getImgName = (props: any) => (props.showGreyLogo ? 'solv-grey' : 'solv_dark');

const getImagePath = (props: any) => `/images/logo/${getImgName(props)}.svg`;

type OwnLogoProps = {
  className?: string;
  height?: number;
  handleLogoOnClick?: (...args: any[]) => any;
  style?: any;
  showGreyLogo?: boolean;
};

const Logo = (props: OwnLogoProps) => (
  <div className={props.className} onClick={props.handleLogoOnClick} style={props.style}>
    <img alt="Solv" className={s.logoImage} height={props.height} src={getImagePath(props)} />
  </div>
);

Logo.defaultProps = {
  height: 16,
  handleLogoOnClick: goHome,
  style: {},
};

export default withStyles(s)(Logo);
